module.exports = __webpack_public_path__ + "static/Arnold-b17126a77aab49421e5455c85a1794ac.jpeg";